export const MEDIA_QUERIES = Object.freeze({
  /*
    Use example:

    ${MEDIA_QUERIES.mobile} {
      .background {
        display: none;
      }
    }
  */

  mobile: '@media (max-width: 576px)',
  tablet: '@media (min-width: 577px) and (max-width: 768px)',
  desktop: '@media (min-width: 769px) and (max-width: 1024px)',
  large: '@media (min-width: 1025px)',
  smallScreen: '@media (max-width: 1200px)',
  bigScreen: '@media (min-width: 768px)',
});

export const Z_INDEX = Object.freeze({
  content: '0',
  overContent: '1',
  header: '2',
  footer: '2',
  modal: '3',
  dropDown: '4',
});
